// components/filters/Filter.jsx
import React, { useState } from 'react';
import CurFt from "../../components/CurFt";

const HolidayFilter = ({
    results,
    filters,
    setFilters,
    priceBounds,
    durationBounds,
    filteredResults
}) => {
    React.useEffect(() => {
        setMinPrice(filters.priceRange[0] || 0)
        setMaxPrice(filters.priceRange[1] || 0)
        setMin(filters.priceRange[0] || 0)
        setMax(filters.priceRange[1] || 0)
    }, [filters]);
    const [minPrice, setMinPrice] = useState(0);
    const [maxPrice, setMaxPrice] = useState(0);

    const [min, setMin] = useState(0);
    const [max, setMax] = useState(0);

    const handleMinChange = (e) => {
        const value = Math.min(Number(e.target.value), maxPrice - 1000);
        setMinPrice(value);
        setFilters(prev => ({
            ...prev,
            priceRange: [
                value,
                priceBounds[1]
            ]
        }))
    };

    const handleMaxChange = (e) => {
        const value = Math.max(Number(e.target.value), minPrice + 1000);
        setMaxPrice(value);
        setFilters(prev => ({
            ...prev,
            priceRange: [
                priceBounds[0],
                value
            ]
        }))
    };
    /* ---------------- UNIQUE OPTIONS ---------------- */
    const FilterSection = ({ title, children }) => (
        <div className="mb-6 border-b pb-4">
            <h3 className="text-sm font-semibold mb-3 text-gray-700">
                {title}
            </h3>
            {children}
        </div>
    );

    const destinationCities = React.useMemo(() => {
        return [...new Set(results.map(r => r.dep_city_name))];
    }, [results]);

    const themeOptions = React.useMemo(() => {
        return [
            ...new Set(
                results.flatMap(r =>
                    r.theme_names?.split(",").map(t => t.trim()) || []
                )
            )
        ];
    }, [results]);

    const inclusionOptions = React.useMemo(() => {
        return [
            ...new Set(
                results.flatMap(r =>
                    r.inclusion_names?.split(",").map(i => i.trim()) || []
                )
            )
        ];
    }, [results]);

    /* ---------------- UI ---------------- */

    return (
        <div className="w-80 bg-white rounded-2xl shadow-sm p-6 sticky top-4 h-fit">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-lg font-semibold">Filters</h2>
                <button
                    onClick={() => setFilters({
                        priceRange: priceBounds,
                        durationRange: [1, 20],
                        flightType: "all",
                        depCities: [],
                        desCities: [],
                        hotelStars: [],
                        selectedThemes: [],
                        selectedInclusions: [],
                        sortBy: ""
                    })}
                    className="text-sm text-blue-600"
                >
                    Clear All
                </button>
            </div>

            <FilterSection title="Price Range">
                {/* Slider Container */}
                <div className="relative h-2 mb-6">
                    {/* Background Track */}
                    <div className="absolute w-full h-2 bg-gray-200 rounded-full"></div>

                    {/* Active Track */}
                    <div
                        className="absolute h-2 bg-blue-500 rounded-full"
                        style={{
                            left: `${((minPrice - min) / (max - min)) * 100}%`,
                            right: `${100 - ((maxPrice - min) / (max - min)) * 100}%`
                        }}
                    ></div>

                    {/* Min Handle */}
                    <input
                        type="range"
                        min={min}
                        max={max}
                        value={minPrice}
                        onChange={handleMinChange}
                        className="absolute w-full h-2 appearance-none bg-transparent pointer-events-none [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-5 [&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-blue-600 [&::-webkit-slider-thumb]:cursor-pointer [&::-webkit-slider-thumb]:pointer-events-auto [&::-webkit-slider-thumb]:border-2 [&::-webkit-slider-thumb]:border-white [&::-webkit-slider-thumb]:shadow-md"
                    />

                    {/* Max Handle */}
                    <input
                        type="range"
                        min={min}
                        max={max}
                        value={maxPrice}
                        onChange={handleMaxChange}
                        className="absolute w-full h-2 appearance-none bg-transparent pointer-events-none [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-5 [&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-blue-600 [&::-webkit-slider-thumb]:cursor-pointer [&::-webkit-slider-thumb]:pointer-events-auto [&::-webkit-slider-thumb]:border-2 [&::-webkit-slider-thumb]:border-white [&::-webkit-slider-thumb]:shadow-md"
                    />
                </div>

                {/* Price Display */}
                <div className="flex justify-between items-center">
                    <div className="text-center">
                        <div className="text-sm font-bold text-gray-700">
                            {/* {formatPrice(minPrice)} */}
                            <CurFt currency={filteredResults[0]?.currency?.name || 'INR'} price={parseFloat(minPrice)} />
                        </div>
                    </div>
                    <div className="text-center">
                        <div className="text-sm font-bold text-gray-700">
                            {/* {formatPrice(maxPrice)} */}
                            <CurFt currency={filteredResults[0]?.currency?.name || 'INR'} price={parseFloat(maxPrice)} />
                        </div>
                    </div>
                </div>

            </FilterSection>

            {/* DURATION */}
            <FilterSection title="Duration (Nights)">

                <input
                    type="range"
                    min={durationBounds[0]}
                    max={durationBounds[1]}
                    value={filters.durationRange[1]}
                    onChange={(e) =>
                        setFilters({
                            ...filters,
                            durationRange: [
                                durationBounds[0],
                                Number(e.target.value)
                            ]
                        })
                    }
                    className="w-full price-slider"
                />

                <div className="flex justify-between text-sm font-medium mt-2">
                    <span>{durationBounds[0]}N</span>
                    <span>{filters.durationRange[1]}N</span>
                </div>

            </FilterSection>

            {/* FLIGHT TYPE */}
            <FilterSection title="Flight">
                <div className="flex gap-2">
                    {["all", "with", "without"].map(type => (
                        <button
                            key={type}
                            onClick={() =>
                                setFilters({ ...filters, flightType: type })
                            }
                            className={`px-3 py-1 rounded-full text-sm border ${filters.flightType === type
                                ? "bg-blue-600 text-white"
                                : "bg-gray-100"
                                }`}
                        >
                            {type === "all"
                                ? "All"
                                : type === "with"
                                    ? "With Flight"
                                    : "Without Flight"}
                        </button>
                    ))}
                </div>
            </FilterSection>

            <FilterSection title="Departure City">

                {destinationCities.map(city => (
                    <label key={city} className="flex gap-2 mb-2">
                        <input
                            type="checkbox"
                            checked={filters.depCities.includes(city)}
                            onChange={() => {
                                const updated = filters.depCities.includes(city)
                                    ? filters.depCities.filter(c => c !== city)
                                    : [...filters.depCities, city];

                                setFilters({ ...filters, depCities: updated });
                            }}
                        />
                        {city}
                    </label>
                ))}

            </FilterSection>

            <FilterSection title="Themes">

                {themeOptions.map(theme => (
                    <label key={theme} className="flex gap-2 mb-2">
                        <input
                            type="checkbox"
                            checked={filters.selectedThemes.includes(theme)}
                            onChange={() => {
                                const updated =
                                    filters.selectedThemes.includes(theme)
                                        ? filters.selectedThemes.filter(t => t !== theme)
                                        : [...filters.selectedThemes, theme];

                                setFilters({
                                    ...filters,
                                    selectedThemes: updated
                                });
                            }}
                        />
                        {theme}
                    </label>
                ))}

            </FilterSection>

            <FilterSection title="Inclusions">

                {inclusionOptions.map(item => (
                    <label key={item} className="flex gap-2 mb-2">
                        <input
                            type="checkbox"
                            checked={filters.selectedInclusions.includes(item)}
                            onChange={() => {
                                const updated =
                                    filters.selectedInclusions.includes(item)
                                        ? filters.selectedInclusions.filter(i => i !== item)
                                        : [...filters.selectedInclusions, item];

                                setFilters({
                                    ...filters,
                                    selectedInclusions: updated
                                });
                            }}
                        />
                        {item}
                    </label>
                ))}

            </FilterSection>

            {/* STAR RATING */}
            <FilterSection title="Star Rating">
                {[5, 4, 3, 2, 1].map(star => (
                    <label key={star} className="flex items-center gap-2 mb-2">
                        <input
                            type="checkbox"
                            checked={filters.hotelStars.includes(String(star))}
                            onChange={() => {
                                const updated = filters.hotelStars.includes(String(star))
                                    ? filters.hotelStars.filter(s => s !== String(star))
                                    : [...filters.hotelStars, String(star)];

                                setFilters({ ...filters, hotelStars: updated });
                            }}
                        />
                        <span>{star} Star</span>
                    </label>
                ))}
            </FilterSection>

        </div>
    );
};

export default HolidayFilter;